import { RECEIVE_PRODUCTS } from "../actions/type";

// 🧾 Product Interface
export interface Product {
  id: number | string;
  title?: string;
  slug?: string;
  price?: number | string;
  delPrice?: number | string;
  proImg?: string;
  [key: string]: any; // allows flexibility for additional fields
}

// 🧾 State Interface
export interface ProductState {
  products: Product[];
  symbol: string;
}

// 🧾 Action Interface
export interface ProductAction {
  type: string;
  products?: Product[];
}

// 🧾 Initial State
const initialState: ProductState = {
  products: [],
  symbol: "$",
};

// 🧠 Reducer
const productReducer = (
  state: ProductState = initialState,
  action: ProductAction
): ProductState => {
  switch (action.type) {
    case RECEIVE_PRODUCTS:
      return {
        ...state,
        products: action.products ?? [], // fallback if undefined
      };

    default:
      return state;
  }
};

export default productReducer;
